import { SidebarMenuButton, SidebarMenuItem } from '@/components/ui/sidebar';
import { MessageSquare } from 'lucide-react';

export const ZY_FEEDBACK_URL = 'https://airtable.com/appnKfFG561219Uh2/pagKqQPyp6l83I5Q0/form';

export function ZyFeedbackButton() {
    return (
        <SidebarMenuItem>
            <SidebarMenuButton
                asChild
                tooltip="Feedback"
            >
                <a
                    href={ZY_FEEDBACK_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <MessageSquare className="h-4 w-4" />
                    <span>Feedback</span>
                </a>
            </SidebarMenuButton>
        </SidebarMenuItem>
    );
}
